import cleanedFilename from '~/util/cleanedFilename';

export default {
  EVENT_CONTAINER: `${cleanedFilename(__filename)}-event-container`,
  FIELD_CONTAINER: `${cleanedFilename(__filename)}-field-container`,
};
